<template>
<div class="grid p-2" :data_id="line.id" :data_type="type">

<div class="col-12 section_wrap" :class="{'section_wrap_selected':show_children,'deactive_line':!line.active,'inputfield_wrap':is_inputfield }">
<div class="grid" >

<!--name-->
<div class="col-10 md:col-11 pl-3 sortable_element_section_name pt-1 pb-0"  @click="toogleChildren"  @dblclick="gotoItem">

<div class="col-12 md:col-9">
<template v-if="type=='section'">
<p class="text-primary mt-1 mb-0 pt-1" v-html="computedname"></p>
</template>
<template v-if="type=='inputfield'">
<router-link class="text-primary mt-1 mb-0 pt-1 no-underline" :to="{ name: 'Question' , params: { id: line.id }}">{{computedname}}</router-link>
</template>



</div>

<div class="col-12 md:col-1 hide_on_mobile">
<p class="text-primary  mt-1 mb-0 pt-1  ">
<b>
<span class="primary-text " v-if="linetype">{{linetype}} </span>
<span class="primary-text " v-if="inputfieldscount">{{inputfieldscount}} Soru</span>


</b>
</p>
</div>

<div class="col-12 md:col-2 hide_on_mobile">
<p class="text-primary  mt-1 mb-0 pt-1 ">
<b>
    <template  v-if="$store.state.questionlists.questionlist.calculate_points">
        <template v-if="line.active">
            <span v-if="line.points || line.points===0" class="primary-text">  {{line.points}} {{$store.state.languages.lang_phrases.puan}}</span>
            <span v-else class="text-red-500">   {{$store.state.languages.lang_phrases.puan}}</span>
        </template>
        <template v-else>
            <span class="text-primary">Deaktif</span>
        </template>
        
    </template>

</b>
</p>
</div>


</div>
<!--name-->

<!--buttons-->
<div class="col-2 md:col-1 sortable_element_section_name pt-1 pb-0">
<div class="flex justify-content-end flex-wrap pr-3">

<!-- section menu-->
<template v-if="type=='section'">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle" aria-haspopup="true" :aria-controls="'line_menu'+line.id" class="p-button-primary p-button-text p-button-sm mt-0"   />
<Menu :id="'line_menu'+line.id" ref="menu" :model="sectiondropdown" :popup="true">
<template #item="{item}">  
<a class="p-menuitem-link" role="menuitem" @click="item.command(item.route,line.id)">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>
</Menu>	
</template>
<!-- section menu-->

<!-- inputfield menu-->
<template v-if="type=='inputfield'">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle" aria-haspopup="true" :aria-controls="'line_menu'+line.id" class="p-button-primary p-button-text p-button-sm mt-03"   />
<Menu :id="'line_menu'+line.id" ref="menu" :model="inputfielddropdown" :popup="true">
<template #item="{item}">  
<a class="p-menuitem-link" role="menuitem" @click="item.command(item.route,line.id)">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>
</Menu>	
</template>
<!-- inputfield menu-->

</div>
</div>
<!--buttons-->
</div>
</div>


<!--children-->
<div class="col-12 pt-0 pb-0 pl-5 pr-0" v-if="show_children">
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading && data">
	<div class="child_wrap">
	<h4>Alt Bölümler</h4>
	<hr/>
	<SortableArray :list="data.childsections" :groupname="'sections'" type="section" :datacontainer="line"></SortableArray>
	</div>
	<div class="child_wrap">
	<h4>Sorular</h4>
	<SortableArray :list="data.inputfields" :groupname="'inputfields'" type="inputfield" :datacontainer="line"></SortableArray>
	</div>


</template>

</div>
<!--children-->
</div>
</template>

<script>
export default {

  name: 'LineItem',
  props:["line","type","highlightterm"],
  data () {
    return {
    	show_children:false,
    	loading:true,
    	data:null,
    	sectiondropdown: [
    		{
                label: 'Düzenle',
                icon: 'pi pi-pencil',
                route:"QuestionlistsSection",
                command: (argument,id) => {
	                   this.gotoPage("Section", { id:this.line.id })
	                }
            },
            {   
                label: 'Bölüm Ekle',
                icon: 'pi pi-plus',
                route:"QuestionlistsNewSection",
                command: (route,id) => {
	                   this.gotoPage(route,{parent_id:id})
	                }
            },
            {
                label: 'Soru Ekle',
                icon: 'pi pi-plus',
                route:"QuestionlistsNewQuestion",
                command: (route,id) => {
	                   this.gotoPage(route,{parent_id:id})
	                }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                command: (argument,id) => {
                		console.log(id)
	                   this.deleteItem("inputfieldsection",id)
	                }
            },
    	],
    	inputfielddropdown: [
    		{
                label: 'Düzenle',
                icon: 'pi pi-pencil',
                route:"Question",
                command: (route,id) => {
                    console.log("question")
                       this.gotoPage(route,{id:id})
                    }
            },
            {
                label: 'Kopyala',
                icon: 'pi pi-copy',
                route:"Question",
                command: (route,id) => {
                       this.copyQuestion(id)
                    }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                argument:"inputfield",
                command: (argument,id) => {
                	console.log(id)
	                   this.deleteItem("inputfield",id)
	                }
            },
    	],
    }
  },
  computed:{
    is_inputfield()
    {
        if(this.type=="inputfield")
        {
            return true
        }

        return false
    },
    computedname()
    {
        if(this.highlightterm)
        {
            let name = this.line.name
            let highlightterm = this.highlightterm
            let text = name.replace( `${highlightterm}`, "<span style='color:#fff;background-color:#352f8d;font-weight:bold'>"+highlightterm+'</span>');
            //console.log(text)
            return text
        }

        else
        {
            return this.line.name
        }
    },
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
    inputfieldscount()
    {
        if(this.line.inputfields && this.line.inputfields.length)
        {
            return this.line.inputfields.length
        }
    },
    linetype()
    {
        if(this.line.type=="text")
        {
            return "Text"
        }
        if(this.line.type=="longtext")
        {
            return "Uzun Text"
        }
        if(this.line.type=="number")
        {
            return "Sayı"
        }
        if(this.line.type=="boolean")
        {
            return "Doğru / Yanlış"
        }
        if(this.line.type=="select")
        {
            return "Seçim"
        }
        if(this.line.type=="columns")
        {
            return "Sütunlar"
        }
        if(this.line.type=="multiselect")
        {
            return "Çoklu Seçim"
        }
        if(this.line.type=="listselect")
        {
            return "Listeden Seçim"
        }
        if(this.line.type=="listinput")
        {
            return "Eklemeli Liste"
        }        
        if(this.line.type=="readonlytext")
        {
            return "Düz Metin"
        }
        
    },
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.getChildDataNoChilren()
  			
  		}
  	}
  },
  methods:{
    copyQuestion(id)
    {
        let formdata = new FormData()
        this.generalSubmission(formdata,"questionlists/inputfield/duplicate/"+id,this.aftercopyQuestion)
        console.log(id)
    },
    aftercopyQuestion(response)
    {
        console.log(response.data)
        this.$router.push({ name: 'Question', params: { id:response.data.id } })
    },
  	toggle(event) {
        console.log(event);
        this.$refs.menu.toggle(event);
    },
    toogleChildren()
    {
    	if(this.type=="section")
    	{
    		if(this.show_children)
	    	{
	    		this.show_children = false
	    	}
	    	else
	    	{
	    		
	    		this.getChildData()
	    	}

    	}
    	
    	
    },
    gotoItem()
    {
    	console.log("gotoItem")
    	if(this.type=="section")
    	{
    		this.$router.push({ name: 'Section', params: { id:this.line.id } }) 
    	}
    	if(this.type=="inputfield")
    	{
    		this.$router.push({ name: 'Question', params: { id:this.line.id } }) 
    	}
    },
    async getChildData()
    {
    	this.show_children = true
    	this.loading = await true
    	console.log(this.$route.params.id)
    	this.data = await this.generalApiGetWithoutLoader("questionlists/section/"+this.line.id)
    	await console.log(this.data)    	
    	this.loading = await false
    },
    async getChildDataNoChilren()
    {
    	//this.show_children = true
    	this.loading = await true
    	this.data = await this.generalApiGetWithoutLoader("questionlists/section/"+this.line.id)
    	this.loading = await false
    },
  }
};
</script>

<style lang="css" scoped>
</style>